import { get, over, set } from "lodash";
import React, { useState, useRef } from "react";
import ImageMapper from 'react-image-mapper';
import { Modal, Button, Overlay } from "react-bootstrap";
import axios from 'axios';
import { getAuthHeader } from "./Util";
import loader from '../page_preload.gif'
import { HOMEURL } from "./constants/APIConstants";

function RectangleHotspotCapture() {
  const imageRef = useRef(null); // Reference to the image
  const [showhotspot, setShowHotspot] = useState(false);
  const [hotspot, setHotspot] = useState([]);
  const [overlays, setOverlays] = useState([]);
  const [HotspotPoints, setHotspotPoints] = useState([]);
  const productNoRef = useRef();
  const [Msg, setMsg] = useState([]);
  const [imagePath, setImagePath] = useState('');
  const [Loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [HotSpotData, setHotSpotData] = useState([]);
  const [validProdNum, setvalidProdNum] = useState(false);
  const [Directory, setDirectory] = useState('');

  const handleMouseDown = (event) => {
    const img = imageRef.current;
    const rect = img.getBoundingClientRect();
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;
    setOverlays([...overlays, { x, y }]);
    setHotspot(prevItems => [...prevItems, x.toFixed(0)]);
    setHotspot(prevItems => [...prevItems, y.toFixed(0)]);

  };


  const closeModal = () => {
    setShowHotspot(false);
  };

  const onvalueChange = () => {
    var value = document.getElementById("myDia").value;
    setLoading(true)
    setImagePath(`${process.env.REACT_APP_DIAGRAM_PATH}` + `${Directory}` + '/' + value.split('$')[1]);
    setLoading(false);
    setHotspot([]);
    setOverlays([]);
    document.getElementById('coo').value = '';
    document.getElementById('hotspotName').value = '';
    document.getElementById('partNumber').value = '';
    getData();
  };

  const handleClick = () => {
    let urlprod;
    var product = productNoRef.current.value;
    setMsg([]);
    setvalidProdNum(false);
    if (product === '') {
      setMsg(prevItems => [...prevItems, "Please Enter Product Number."]);
      return
    }
    urlprod = `${process.env.REACT_APP_API}/proxy/get?input=/Files/files/GetDiagramDetail/` + product;
    setLoading(true);
    axios.get(urlprod, {
      headers: {
        ...getAuthHeader()
      }
    })
      .then((res) => {
        if (res.data.length > 0) {
          setMsg([]);
          //setData(res.data);
          setvalidProdNum(true);
          setLoading(false);
          document.getElementById("myDia").options.length = 0; // Clear existing options
          res.data.map((con, index) => {
            if (index === 0) {
              setDirectory(con.Directory);
              setImagePath(`${process.env.REACT_APP_DIAGRAM_PATH}` + con.Directory + '/' + con.Diagrame);
            }
            var x = document.getElementById("myDia");
            var option = document.createElement("option");
            option.text = con.Description;
            option.value = con.picture_Id + '$' + con.Diagrame;
            x.add(option);
          })
          getData();

        }
        else {
          setvalidProdNum(false);
          setLoading(false);
          setMsg(prevItems => [...prevItems, "No Diagram Details found!"]);
        }

      }, (error) => {
        setLoading(false);
        setMsg([]);
        setvalidProdNum(false);

      })

  }


  const getData = () => {
    {
      var Picture = document.getElementById("myDia").value.split('$')[0];
      setLoading(true);
      let geturl = `${process.env.REACT_APP_API}/proxy/get?input=/Files/files/GetHotspot/` + Picture;
      axios.get(geturl, {
        headers: {
          ...getAuthHeader()
        }
      })
        .then((res) => {
          if (res.data.length > 0) {
            setHotSpotData([]);
            setOverlays([]); // Clear overlays
            setHotspotPoints([]); // Clear Hotspot Points
            setHotSpotData(res.data);
            res.data.map((con, index) => {
              const values = con.coordinates.split(","); // Split by comma
              const pairs = [];
              for (let i = 0; i < values.length; i += 2) {
                for (let i = 0; i < values.length; i += 2) {
                  const x = parseInt(values[i]);
                  const y = parseInt(values[i + 1]);
                  pairs.push({ x, y });
                }
              }
              pairs.map((pos, index) => (
                setHotspotPoints(prevItems => [...prevItems, { x: pos.x, y: pos.y }])
              ))
            })
            setLoading(false);
          }
          else {
            setHotSpotData([]);//To dispaly No Data Found in Table
            setOverlays([]);// To clear overlays
            setHotspotPoints([]);// To clear Hotspot Points
            setLoading(false);
          }
        }, (error) => {
          setLoading(false);
          setMsg(prevItems => [...prevItems, "Error Occurred while fetching data."]);
        })
    }

  }


  const handleCheckBlur = (event) => {
    setMsg([]);
    if (event.target.value == "") {
      setvalidProdNum(false);
    }
    else {
      let urlprod;
      var product = event.target.value;
      setLoading(true);
      setvalidProdNum(false);
      urlprod = `${process.env.REACT_APP_API}/proxy/get?input=/Files/files/Checkproductnumberexist/` + event.target.value;
      axios.get(urlprod, {
        headers: {
          ...getAuthHeader()
        }
      })
        .then((res) => {
          if (res.data == 'Product exists') {
            setMsg(prevItems => [...prevItems, "Product Number exists.Click Submit to Proceed."]);
            setLoading(false);
          }
          else {
            setMsg(prevItems => [...prevItems, res.data]);
            setvalidProdNum(false);
            setLoading(false);
          }

        }, (error) => {
          setLoading(false);
          setvalidProdNum(false);
          setMsg(prevItems => [...prevItems, "Error Occurred while checking product number"]);
        })
    }
  };

  const handleSaveClick = () => {
    let urlprod;
    var Picture = document.getElementById("myDia").value.split('$')[0];
    var HotspotName = document.getElementById("hotspotName").value;
    var Vertices = document.getElementById("coo").value;
    var PartNumber = document.getElementById("partNumber").value;
    urlprod = `${process.env.REACT_APP_API}/proxy/get?input=/Files/files/SaveHotspot/` + Picture + '/' + HotspotName + '/' + Vertices + '/' + PartNumber;

    setMsg([]);
    if (PartNumber === '') {
      setMsg(prevItems => [...prevItems, "Please Enter Valid Part Number."]);
      return;
    }
    if (HotspotName === '') {
      setMsg(prevItems => [...prevItems, "Please Enter HotSpot Name."]);
      return;
    }
    if (Vertices === '') {
      setMsg(prevItems => [...prevItems, "Please Select Hotspot Area from image."]);
      return;
    }

    setLoading(true);
    axios.get(urlprod, {
      headers: {
        ...getAuthHeader(),
      }
    })
      .then((res) => {
        if (res.data.length > 0) {
          getData();
          setOverlays([]); // Clear overlays after saving
          setHotspot([]); // Clear hotspot coordinates

          document.getElementById('coo').value = '';
          document.getElementById('hotspotName').value = '';
          document.getElementById('partNumber').value = '';
        }
        setLoading(false);
      }, (error) => {
        setLoading(false);

      })



  }


  const handleBlur = (event) => {
    if (event.target.value != '') {
      let urlprod;
      setLoading(true);
      setMsg([])
      urlprod = `${process.env.REACT_APP_API}/proxy/get?input=/Files/files/Checkpartnumberexist/` + event.target.value.toUpperCase();
      axios.get(urlprod, {
        headers: {
          ...getAuthHeader()
        }
      })
        .then((res) => {
          if (res.data) {
            setLoading(false);
          }

        }, (error) => {
          setLoading(false);
          document.getElementById("partNumber").value = '';
          if (error.response != null) {
            setMsg(prevItems => [...prevItems, error.response.data]);
          }
          else {
            setMsg(prevItems => [...prevItems, "Error Occurred while fetching data."]);
          }
        });
    }
  }
  const mystyle = {
    // position: "fixed",
    // bottom: "0",
    // left: "0",
    // width: "100%",
    // zindex: "1050",
    color: "red",
    //opacity: "1"
  }
  const makeUpperCase = (event) => {
    event.target.value = event.target.value.toUpperCase();
  }
  const textHotspot = (event) => {
    setShowHotspot(true);
    event.preventDefault();
  }

  const onDelete = (HotSpot_Name, Part_Number) => {
    let urlprod;
    var Picture = document.getElementById("myDia").value.split('$')[0];
    const confirmed = window.confirm("Are you sure you want to delete this Hotspot?");
    if (confirmed) {
      urlprod = `${process.env.REACT_APP_API}/proxy/get?input=/Files/files/DeleteHotspot/` + Picture + '/' + HotSpot_Name + '/' + Part_Number;
      setLoading(true);
      axios.get(urlprod, {
        headers: {
          ...getAuthHeader()
        }
      })
        .then((res) => {
          getData();
          setLoading(false);

        }, (error) => {
          setLoading(false);
          setMsg(prevItems => [...prevItems, "Error Occurred while deleting data."]);
        })
    }
  }

  const cancelHotspot = (event) => {
    setOverlays([]); // Clear overlays
    setHotspot([]); // Clear hotspot coordinates
    event.preventDefault();
  }

  return (


    <div>
      <div style={{ position: 'relative', boxSizing: 'border-box' }}>
        {Loading && <div>
          <div style={{
            position: 'fixed',
            height: '100%',

            zIndex: 999,
            display: 'block', width: '100%', textAlign: 'center'
            , top: '50%', right: '1%',
          }}>
            <img src={loader} alt="loading..." />
            <br />
            <b>Please wait for the moment....</b>
          </div>
        </div>}
        {Loading ? <div style={{ opacity: '0.5' }}>

        </div> : null}
      </div>


      <div class="form-row">

        <div class="form-group col-md-2">
          <label> <b>Enter Product Number to Begin: </b></label>
          <div class="input-group">
            <input type="text" class="form-control" placeholder="Enter text" ref={productNoRef} onBlur={handleCheckBlur} onKeyUp={makeUpperCase} />
            <button class="btn btn-primary" onClick={handleClick}>Submit</button>
          </div>
        </div>
        {validProdNum && (
          <>
            <div class="form-group col-md-2">
              <label> <b>Select Diagram: </b></label>
              <select class="custom-select" id="myDia" onChange={onvalueChange} ></select>
            </div>

            <div class="form-group col-md-2">
              <label> <b>Part Number: </b></label>
              <input type="text" id="partNumber" class="form-control" placeholder="Enter Part Number" onBlur={handleBlur} onKeyUp={makeUpperCase} />
            </div>
            <div class="form-group col-md-2">
              <label> <b>HotSpot Name: </b></label>
              <div class="input-group">
                <input type="text" id="hotspotName" class="form-control" placeholder="HotSpot Name" />
              </div>
            </div>
            <div class="form-group col-md-3">
              <label> <b>Select Coordinates from Image: </b></label>
              <div class="input-group">
                <input type="text" class="form-control" id="coo" value={hotspot} placeholder="Coordinates" />
                <button class="btn btn-primary" onClick={handleSaveClick} >Save</button>
              </div>

            </div>
          </>
        )}

      </div>

      {Msg.length > 0 && (
        <div class="alert alert-danger" role="alert" style={mystyle}>
          {Msg.map((msg, index) => (
            <div key={index}>{msg}</div>
          ))}
        </div>
      )}
      {validProdNum && (
        <div class="form-row">
          <div class="form-group col-md-6">
            <h6>Click Edges of the area to create Hotspot and click Save! <b><a href="#" onClick={textHotspot}>Test HotSpot</a></b>
              &nbsp;{overlays.length > 0 && (<b><a style={{ color: "red" }} title="Clears Selected Hotspot" href="#" onClick={cancelHotspot}>Clear HotSpot</a></b>)}
            </h6>
            <div
              style={{
                position: "relative",
                display: "inline-block",
                border: "1px solid black",
                width: "600px",
                height: "500px",
                overflow: "auto",
              }}
            >
              <img
                ref={imageRef}
                src={imagePath}
                alt="No Image Found"
                style={{ cursor: "crosshair" }}
                onMouseDown={handleMouseDown}
              />

              {overlays.map((pos, index) => (
                <div
                  key={index}
                  style={{
                    position: 'absolute',
                    top: pos.y - 5,
                    left: pos.x - 5,
                    width: 8,
                    height: 8,
                    backgroundColor: 'red',
                    borderRadius: '50%',
                    pointerEvents: 'none', // So clicks go through the overlays
                  }}
                />
              ))}

              {HotspotPoints.map((pos, index) => (//Shows exixsting hotspots
                <div
                  key={index}
                  style={{
                    position: 'absolute',
                    top: pos.y - 5,
                    left: pos.x - 5,
                    width: 8,
                    height: 8,
                    backgroundColor: 'Blue',
                    borderRadius: '50%',
                    pointerEvents: 'none', // So clicks go through the overlays
                  }}
                />
              ))}


            </div>
          </div>

          <div class="form-group col-md-6">
            <div style={{ overflowX: "auto", maxWidth: "100%" }}>
              <table className="table table-striped" style={{ minWidth: "760px", marginBottom: 0 }}>
                <thead>
                  <tr>
                    <th>HotSpot Name</th>
                    <th>Part Number</th>
                    <th style={{ minWidth: "260px" }}>Coordinates</th>
                    <th style={{ minWidth: "90px", whiteSpace: "nowrap", position: "sticky", right: 0, background: "#B6B8B9", zIndex: 2 }}>Delete</th>
                  </tr>
                </thead>
                <tbody>
                  {!HotSpotData.length > 0 && (
                    <tr>
                      <td colSpan={4}><center>No Data Found</center></td>
                    </tr>
                  )}
                  {HotSpotData.map((item, index) => (
                    <tr key={item.SrNo}>
                      {/* <td>{item.SrNo}</td> */}
                      <td>{item.hotSpot_Name}</td>
                      <td>{item.part_Number}</td>
                      <td style={{ maxWidth: "320px", whiteSpace: "normal", overflowWrap: "anywhere", wordBreak: "break-word", textAlign: "left" }}>{item.coordinates}</td>
                      <td style={{ minWidth: "90px", whiteSpace: "nowrap", position: "sticky", right: 0, background: index % 2 === 0 ? "white" : "#f2f2f2", zIndex: 1 }}>
                        <button onClick={() => onDelete(item.hotSpot_Name, item.part_Number)}>Delete</button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

          </div>



        </div>
      )}
      <Modal
        size="lg"
        /* dialogClassName={"my-modal"}
        top */
        scrollable
        show={showhotspot}
        onHide={closeModal}
      >
        <Modal.Header closeButton>
          <Modal.Title>Photo</Modal.Title>
        </Modal.Header>
        <Modal.Body id="PopupId">
          <h1>Image Map with Hotspots</h1>


          <div> <img src={imagePath} useMap="#image-map" class="map" />
            <map name="image-map" >
              {HotSpotData.map((point, index) => (
                <area shape="poly" key={index} coords={point.coordinates} href={HOMEURL + "?searchtext=" + point.part_Number} target="_blank" alt="Hotspot" title={ point.hotSpot_Name+ "\n" + point.part_Number} data-maphilight='{"alwaysOn":true,"stroke":false,"fillColor":"efb1a6","fillOpacity":"0.3"}' />
              ))}
            </map>
          </div>

        </Modal.Body>
      </Modal>
      <br />
      <br />
    </div>
  );
}
export default RectangleHotspotCapture;
